export function getLocale() {
    return (document.documentElement && document.documentElement.lang) || 'en';
}
